import React, { useState } from 'react';
import styles from './Setting.module.css';

const StoreDetails = ({ storeInfo, setStoreInfo }) => {
  const [isEditing, setIsEditing] = useState(false); // To toggle editing mode
  const [tempStoreInfo, setTempStoreInfo] = useState({ ...storeInfo }); // Temporary state for editing
  const [isLogoChanged, setIsLogoChanged] = useState(false); // To track logo changes
  const [showModal, setShowModal] = useState(false); // Modal visibility state

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setTempStoreInfo({
          ...tempStoreInfo,
          businessLogo: reader.result,
        });
      };
      reader.readAsDataURL(file);
      setIsLogoChanged(true); // Set flag when logo is changed
    }
  };

  const handleRemoveLogo = () => {
    setTempStoreInfo({
      ...tempStoreInfo,
      businessLogo: '', // Clear the logo
    });
    setIsLogoChanged(false); // Reset logo change flag
  };

  const handleSaveChanges = () => {
    setShowModal(true); // Show confirmation modal
  };

  const confirmSave = () => {
    setStoreInfo(tempStoreInfo); // Save changes to store info
    setIsEditing(false); // Exit editing mode
    setIsLogoChanged(false); // Disable logo removal button after saving
    setShowModal(false); // Close modal
    alert('Store details saved successfully!');
  };

  const cancelSave = () => {
    setShowModal(false); // Close modal without saving
  };

  const handleCancelEdit = () => {
    setTempStoreInfo({ ...storeInfo }); // Revert changes
    setIsEditing(false); // Exit editing mode
    setIsLogoChanged(false); // Reset logo change flag
  };

  const handleEdit = () => {
    setTempStoreInfo({ ...storeInfo }); // Copy current data into temporary state
    setIsEditing(true); // Enable editing mode
  };

  return (
    <div className={styles.sectionContent}>
      {/* Store Name */}
      <div className={styles.formGroup}>
        <label>Store Name:</label>
        {isEditing ? (
          <input
            type="text"
            value={tempStoreInfo.storeName}
            onChange={(e) =>
              setTempStoreInfo({ ...tempStoreInfo, storeName: e.target.value })
            }
            className={styles.inputField}
          />
        ) : (
          <div className={styles.readOnlyField}>{storeInfo.storeName || 'Not provided'}</div>
        )}
      </div>

      {/* Store Address */}
      <div className={styles.formGroup}>
        <label>Store Address:</label>
        {isEditing ? (
          <textarea
            value={tempStoreInfo.storeAddress}
            onChange={(e) =>
              setTempStoreInfo({ ...tempStoreInfo, storeAddress: e.target.value })
            }
            className={styles.inputField}
            rows="3"
          ></textarea>
        ) : (
          <div className={styles.readOnlyField}>{storeInfo.storeAddress || 'Not provided'}</div>
        )}
      </div>

      {/* Pin Code */}
      <div className={styles.formGroup}>
        <label>Pin Code:</label>
        {isEditing ? (
          <input
            type="text"
            value={tempStoreInfo.pinCode}
            onChange={(e) =>
              setTempStoreInfo({ ...tempStoreInfo, pinCode: e.target.value })
            }
            className={styles.inputField}
          />
        ) : (
          <div className={styles.readOnlyField}>{storeInfo.pinCode || 'Not provided'}</div>
        )}
      </div>

      {/* State */}
      <div className={styles.formGroup}>
        <label>State:</label>
        {isEditing ? (
          <input
            type="text"
            value={tempStoreInfo.state}
            onChange={(e) =>
              setTempStoreInfo({ ...tempStoreInfo, state: e.target.value })
            }
            className={styles.inputField}
          />
        ) : (
          <div className={styles.readOnlyField}>{storeInfo.state || 'Not provided'}</div>
        )}
      </div>

      {/* Business Type */}
      <div className={styles.formGroup}>
        <label>Business Type:</label>
        {isEditing ? (
          <select
            value={tempStoreInfo.businessType}
            onChange={(e) =>
              setTempStoreInfo({ ...tempStoreInfo, businessType: e.target.value })
            }
            className={styles.inputField}
          >
            <option value="">Select Business Type</option>
            <option value="retail">Retail</option>
            <option value="wholesale">Wholesale</option>
            <option value="online">Online</option>
          </select>
        ) : (
          <div className={styles.readOnlyField}>
            {storeInfo.businessType || 'Not provided'}
          </div>
        )}
      </div>

      {/* Business Logo */}
      <div className={styles.formGroup}>
        <label>Business Logo:</label>
        <div className={styles.inputWrapper}>
          {isEditing ? (
            <>
              <input
                type="file"
                accept="image/*"
                onChange={handleLogoChange}
                className={styles.inputField}
              />
              {isLogoChanged && (
                <button
                  type="button"
                  onClick={handleRemoveLogo}
                  className={styles.removeButton}
                >
                  ✖
                </button>
              )}
            </>
          ) : storeInfo.businessLogo ? (
            <img
              src={storeInfo.businessLogo}
              alt="Business Logo"
              className={styles.profileImage}
            />
          ) : (
            <div className={styles.readOnlyField}>No logo uploaded</div>
          )}
        </div>
      </div>

      {/* Action Buttons */}
      {isEditing ? (
        <div className={styles.buttonGroup}>
          <button onClick={handleSaveChanges} className={styles.saveButton}>
            Save Changes
          </button>
          <button onClick={handleCancelEdit} className={styles.cancelButton}>
            Cancel
          </button>
        </div>
      ) : (
        <button onClick={handleEdit} className={styles.saveButton}>
          Edit Store Details
        </button>
      )}

      {/* Modal for Confirmation */}
      {showModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <p>Do you really want to save these changes?</p>
            <div className={styles.modalActions}>
              <button onClick={confirmSave} className={styles.saveButton}>
                Yes
              </button>
              <button onClick={cancelSave} className={styles.cancelButton}>
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StoreDetails;
